import { z } from "zod/v4";
export const GrowSetElementSchema = z.union([
    z.string(),
    z.number(),
    z.coerce.boolean(),
    z.undefined(),
    z.null(),
]);
export const GrowSetSchema = z.array(z.union([
    z.string(),
    z.number(),
    z.coerce.boolean(),
    z.undefined(),
    z.null(),
]));
export function mergeGrowSet({ local, remote, }) {
    const localSet = new Set(local);
    const remoteSet = new Set(remote);
    const resolved = localSet.union(remoteSet);
    const localOnly = localSet.difference(remoteSet);
    const remoteOnly = remoteSet.difference(localSet);
    return {
        resolved: [...resolved],
        localOnly: [...localOnly],
        remoteOnly: [...remoteOnly],
    };
}
//# sourceMappingURL=gset.js.map